import { render, staticRenderFns } from "./MediaSectionLandingPage.vue?vue&type=template&id=741c22d8&scoped=true"
import script from "./MediaSectionLandingPage.vue?vue&type=script&lang=js"
export * from "./MediaSectionLandingPage.vue?vue&type=script&lang=js"
import style0 from "./MediaSectionLandingPage.vue?vue&type=style&index=0&id=741c22d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741c22d8",
  null
  
)

export default component.exports